import { AnalyticIdentifier } from '@common/neo.tax';
import { BaseTab, colors, Loading, Stack, Typography, useTabState } from '@ui-components/neo.tax';

import { useAccountingExpense } from '@neo.tax/rd/hooks';
import { AccountingQre } from '@neo.tax/rd/hooks/useAccountingQres';
import { useAnalyticId, useCurrentUserScopeForCurrentCompany } from '@neo.tax/shared';

import { AccountingExpenseGeneralForm } from '../accounting-expense-general-form';
import { AccountingQreDetailsForm } from '../accounting-qre-details-form';
import { Container, BaseTabPanelStyled, BaseTabsStyled, TabPanelContainerStyled } from './accounting-qre-detail.styled';

type AccountingQreDetailProps = {
  expense: AccountingQre;
};

export const AccountingQreDetail = ({ expense: accountingQre }: AccountingQreDetailProps): React.ReactElement => {
  const generalTabId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_TAB);
  const detailTabId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_DETAILS_TAB);
  const tabState = useTabState({ defaultSelectedId: generalTabId });
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();
  const { accountingExpense, loading: accountingExpenseLoading } = useAccountingExpense(
    accountingQre.accountingExpenseId,
  );
  const loading = accountingExpenseLoading || !accountingExpense;

  return (
    <Container direction="column" overflow="hidden" backgroundColor={colors.gray[50]} fullHeight>
      {loading ? (
        <Loading height={300} />
      ) : (
        <>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="space-between"
            paddingX={6}
            paddingY={2.5}
            backgroundColor={colors.gray[200]}
          >
            <Typography fontWeight="medium" fontSize="lg">
              {accountingExpense.displayName}
            </Typography>
          </Stack>
          <BaseTabsStyled state={tabState}>
            <BaseTab label="General" tabId={generalTabId} />
            {!limitAccessToFinancialData ? <BaseTab label="Details" tabId={detailTabId} /> : <></>}
          </BaseTabsStyled>

          <TabPanelContainerStyled>
            <BaseTabPanelStyled state={tabState} tabId={generalTabId}>
              <AccountingExpenseGeneralForm accountingExpense={accountingExpense} />
            </BaseTabPanelStyled>
            {!limitAccessToFinancialData ? (
              <BaseTabPanelStyled state={tabState} tabId={detailTabId}>
                <AccountingQreDetailsForm accountingQre={accountingQre} />
              </BaseTabPanelStyled>
            ) : (
              <></>
            )}
          </TabPanelContainerStyled>
        </>
      )}
    </Container>
  );
};
